export enum CsvImportProblemType {
	ERRORS = "errors",
	WARNINGS = "warnings",
}

export interface AttributeProps {
	csv_field_name?: string;
	domain_field_name: string;
}

export interface ImportFormProps {
	attributes: AttributeProps[];
}
